import { render } from "./CookiesAlert.vue?vue&type=template&id=3024cc9c"
import script from "./CookiesAlert.vue?vue&type=script&lang=js"
export * from "./CookiesAlert.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__